import React from 'react';
import PropTypes from 'prop-types';
import TableSortLabel from '@mui/material/TableSortLabel';

export default function SortableTableLabel({
  column,
  sortBy,
  sortOrder,
  onSort,
  color = 'inherit',
}) {
  if (column.sortable === false) return column.label;

  return (
    <TableSortLabel
      active={sortBy === column.id}
      direction={sortBy === column.id ? sortOrder : 'asc'}
      onClick={() => onSort(column.id)}
      sx={{
        color: `${color} !important`,
        '& .MuiTableSortLabel-icon': { color: `${color} !important` },
      }}
    >
      {column.label}
    </TableSortLabel>
  );
}

SortableTableLabel.propTypes = {
  column: PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
    sortable: PropTypes.bool,
  }).isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.oneOf(['asc', 'desc']).isRequired,
  onSort: PropTypes.func.isRequired,
  color: PropTypes.string,
};
